module.exports = __webpack_public_path__ + "static/media/notes_icon1.dfffb449.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/notes/notes_icon1.svg
// module id = 301
// module chunks = 0